import { LRS_BASE_URL_PROD, LRS_BASE_URL_TEST } from "./constants";
import { LrsCredentials, LrsEnvironment, StatementPayload } from "./types";

export const sendStatement = async (
  credentials: LrsCredentials,
  env: LrsEnvironment,
  payload: StatementPayload[],
  isBeacon: boolean,
) => {
  const LRS_BASE_URL = env === "prod" ? LRS_BASE_URL_PROD : LRS_BASE_URL_TEST;

  const url = `${LRS_BASE_URL}/data/xAPI/statements`;
  const authorization = `Basic ${window.btoa(
    credentials.username + ":" + credentials.password,
  )}`;

  if (isBeacon) {
    const body = {
      payload,
      authorization,
    };
    return navigator.sendBeacon(url, JSON.stringify(body));
  }

  const headers = new Headers();
  headers.set("Authorization", authorization);
  headers.set("Content-Type", "application/json");

  return await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });
};
